import { render, staticRenderFns } from "./DrillItem.vue?vue&type=template&id=fa431e1c&scoped=true"
import script from "./DrillItem.vue?vue&type=script&lang=js"
export * from "./DrillItem.vue?vue&type=script&lang=js"
import style0 from "./DrillItem.vue?vue&type=style&index=0&id=fa431e1c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa431e1c",
  null
  
)

export default component.exports